  <div class="account-number-input-title">Enter {{accountFieldTitle}}</div>
  <textarea name="accountNumberInput" class="account-number-input border-solid border-1 border-black resize-y min-h-32 px-4 py-3.5 rounded-md w-full box-border"
      data-testid="accountNums"
      placeholder="Input"
      (input)="onInput()"
      [(ngModel)]="value">
  </textarea>
  <span>Enter {{accountFieldTitle.toLowerCase()}} separated by commas to get specific data. Ex: Value1, Value2, Value3...</span>
